const agencies = [
  "Aberdeen Police Department",
  "Ahoskie Police Department",
  "Alamance County Central Communications",
  "Alamance County Clerk of Superior Court",
  "Alamance County Emergency Management",
  "Alamance County Sheriff's Office",
  "Albemarle Police Department",
  "Alcohol Beverage Commission Enforcement Cumberland County",
  "Alcohol Beverage Commission Enforcement Mecklenburg County",
  "Alcohol Beverage Commission Enforcement Pitt County",
  "Alcohol Beverage Commission Enforcement Wake County",
  "Alcohol Law Enforcement District Headquarters",
  "Alcohol Law Enforcement District I Jacksonville",
  "Alcohol Law Enforcement District II Greenville",
  "Alcohol Law Enforcement District IV Raleigh",
  "Alcohol Law Enforcement District IX Asheville",
  "Alcohol Law Enforcement District V Fayetteville",
  "Alcohol Law Enforcement District VI Greensboro",
  "Alcohol Law Enforcement District VI Harrisburg",
  "Alcohol Law Enforcement District VII Hickory",
  "Alexander County Emergency Management",
  "Alexander County Sheriff's Office",
  "Alleghany County Communications",
  "Alleghany County Emergency Management",
  "Alleghany County Sheriff's Office",
  "Allied Barton Company Police Mecklenburg",
  "Allied Universal Special Police",
  "Alligator River National Wildlife Refuge Complex",
  "Ally Bank",
  "Amtrak Police Department",
  "Anson County Communications Center",
  "Anson County Sheriff's Office",
  "Apex Police Department",
  "Appalachian Regional Healthcare System Company Police",
  "Appalachian State University Police",
  "Archdale Police Department",
  "Ashe County Emergency Management",
  "Ashe County Sheriff's Office",
  "Asheboro Police Department",
  "Asheville Fire Department",
  "Asheville Police Department",
  "Asheville Regional Airport Department of Public Safety",
  "Asheville-Buncombe Technical Community College Police Department",
  "Atrium Health Medical Center",
  "Avery Communications Center",
  "Avery County Emergency Management",
  "Avery County Sheriff's Office",
  "Ayden Police Department",
  "Badin Police Department",
  "Beaufort County Emergency Management",
  "Beaufort County Sheriff's Office",
  "Beaufort Police Department",
  "Beech Mountain Police Department",
  "Belhaven Police Department",
  "Belmont Police Department",
  "Benson Police Department",
  "Bertie and Martin County Regional Jail Windsor",
  "Bertie County 911 Communications",
  "Bertie County Emergency Management",
  "Bertie County Sheriff's Office",
  "Bessemer City Police Department",
  "Biltmore Estate Company Police",
  "Biltmore Farms LLC",
  "Biltmore Forest Police Department",
  "Black Mountain Department of Health and Human Services Police",
  "Black Mountain Police Department",
  "Bladen County Emergency Management",
  "Bladen County Sheriff's Office",
  "Blowing Rock Police Department",
  "Blue Ridge Community College Police Department",
  "Blue Ridge Parkway Ranger",
  "Blue Ridge Public Safety",
  "Boiling Spring Lakes Police Department",
  "Boone Police Department",
  "Brevard Fire Department",
  "Broughton Hospital Police Department",
  "Brunswick County Emergency Management",
  "Brunswick County Sheriff's Office",
  "Buncombe County  Pretrial Release",
  "Buncombe County Emergency Management",
  "Buncombe County Emergency Services",
  "Buncombe County Sheriff's Office",
  "Burgaw Police Department",
  "Burke County Emergency Communications Center",
  "Burke County Emergency Management",
  "Burke County Sheriff's Office",
  "Burlington Police Department",
  "Burnsville Police Department",
  "Butner Public Safety",
  "Cabarrus County Emergency Management",
  "Cabarrus County Sheriff's Office",
  "Caldwell County 911 Communications Center",
  "Caldwell County Emergency Management",
  "Caldwell County Sheriff's Office",
  "Camben County Emergency Management",
  "Camden County Sheriff's Office",
  "Canton Police Department",
  "Cape Carteret Police Department",
  "Cape Fear Valley Health System",
  "Cape Hatteras National Seashore",
  "Cape Lookout National Seashore",
  "Carolina Beach Police Department",
  "Carrboro Police Department",
  "Carteret County Emergency Communications Center",
  "Carteret County Emergency Management",
  "Carteret County Sheriff's Office",
  "Carthage Police Department",
  "Cary Police Department",
  "Caswell County 911 Communications",
  "Caswell County Emergency Management",
  "Caswell County Sheriff's Office",
  "Catawba County 911 Communications Center",
  "Catawba County Emergency Management",
  "Catawba County Sheriff's Office",
  "Central Prison Record Section",
  "Chapel Hill Fire Department",
  "Chapel Hill Police Department",
  "Charlotte Mecklenburg Emergency Management",
  "Charlotte Mecklenburg Fire Department",
  "Charlotte Mecklenburg Police Department",
  "Charlotte Mecklenburg Schools Police Department",
  "Charlotte Water",
  "Chatham County Communications",
  "Chatham County Emergency Management",
  "Chatham County Sheriff's Office",
  "Cherokee County Communications Center",
  "Cherokee County Emergency Management",
  "Cherokee County Sheriff's Office",
  "Cherokee Indian Police Department",
  "Cherry Hospital Police Department",
  "Cherryville Police Department",
  "Chimney Rock State Park",
  "China Grove Police Department",
  "Chocowinity Police Department",
  "Chowan County Communications Center",
  "Chowan County Emergency Management",
  "Chowan County Sheriffs' Office",
  "City-County Bureau of Identification",
  "Claremont Police Department",
  "Clay County Communications",
  "Clay County Emergency Management",
  "Clay County Sheriff's Office",
  "Clayton Police Department",
  "Cleveland County Communications",
  "Cleveland County Emergency Management",
  "Cleveland County Sheriff's Office",
  "Cleveland Police Department",
  "Clinton Police Department",
  "Coats Police Department",
  "Columbus County Emergency Management",
  "Columbus County Emergency Services",
  "Columbus County Sheriff's Office",
  "Columbus Police Department",
  "CoNorth Carolinaord Communications Department",
  "CoNorth Carolinaord Police Department",
  "Conover Police Department",
  "Cornelius Police Department",
  "Cramerton Police Department",
  "Craven County Emergency Management",
  "Craven County Emergency Services",
  "Craven County Sheriff's Office",
  "CREE",
  "Creedmoor Police Department",
  "Cumberland County Emergency Communications Center",
  "Cumberland County Emergency Management",
  "Cumberland County Sheriff's Office",
  "Currituck County Communications Center",
  "Currituck County Emergency Management",
  "Currituck County Sheriff's Office",
  "Dallas Police Department",
  "Dare County Emergency Management",
  "Dare County Sheriff's Office",
  "Davidson College Public Safety",
  "Davidson County Emergency Communications",
  "Davidson County Emergency Management",
  "Davidson County Sheriff's Office",
  "Davidson Police Department",
  "Davie County Communications Center",
  "Davie County Emergency Management",
  "Davie County Sheriff's Office",
  "Denton Police Department",
  "Department of Homeland Security",
  "District Attorney 15A Alamance",
  "District Attorney Office - Guilford",
  "District Attorney Office 01 Pasquotank",
  "District Attorney Office 02 Beaufort, Hyde, Martin, Tyrrell, Washington",
  "District Attorney Office 03A Pitt",
  "District Attorney Office 03B Craven, Carteret, Pamlico **Dist-04**",
  "District Attorney Office 04 Sampson, Duplin, Jones, Onslow",
  "District Attorney Office 05 New Hanover, Pender",
  "District Attorney Office 06B Hertford, Bertie, Northampton",
  "District Attorney Office 07 Edgecombe, Nash, Wilson",
  "District Attorney Office 08 Wayne, Greene, Lenoir",
  "District Attorney Office 09 Granville, Franklin, Henderson, Warren",
  "District Attorney Office 10 Wake",
  "District Attorney Office 11A Harnett, Lee",
  "District Attorney Office 11B Johnston",
  "District Attorney Office 12 Cumberland",
  "District Attorney Office 13 Brunswick, Bladen, Columbus  **District Attorney Office 15 >ARMS**",
  "District Attorney Office 14 Durham",
  "District Attorney Office 15B Orange, Chatham",
  "District Attorney Office 16B Robeson",
  "District Attorney Office 16C Richmond, Anson",
  "District Attorney Office 17A Rockingham",
  "District Attorney Office 17B Surry, Stokes",
  "District Attorney Office 19A Cabarrus",
  "District Attorney Office 19B Randolph, Montgomery",
  "District Attorney Office 19C Rowan",
  "District Attorney Office 19D Moore",
  "District Attorney Office 20A Stanly, Anson, Richmond",
  "District Attorney Office 20B Union",
  "District Attorney Office 21 Forsyth",
  "District Attorney Office 22A Iredell, Alexander",
  "District Attorney Office 22B Davidson, Davie",
  "District Attorney Office 23 Wilkes, Alleghany, Ashe, Yadkin",
  "District Attorney Office 24 Watauga, Avery, Madison, Mitchell, Yancy",
  "District Attorney Office 25 Catawba, Burke, Caldwell",
  "District Attorney Office 26 Mecklenburg",
  "District Attorney Office 27A Gaston",
  "District Attorney Office 27B Cleveland, LiNorth Carolinaoln",
  "District Attorney Office 28 Buncombe",
  "District Attorney Office 29A Rutherford, McDowell",
  "District Attorney Office 29B Henderson, Polk, TransylVeterans Affairsnia",
  "District Attorney Office 30 Haywood, Cherokee, Clay, Graham, Jackson, Macon, Swain",
  "Dobson Police Department",
  "Duck Police Department",
  "Duke Energy",
  "Duke Energy Company Police",
  "Duke University Police Department",
  "Dunn Police Department",
  "Duplin County Communications Center",
  "Duplin County Emergency Management",
  "Duplin County Sheriff's Office",
  "Durham County Communications Center",
  "Durham County Emergency Management",
  "Durham County Fire Department",
  "Durham County Pretrial Services",
  "Durham County Sheriff’s Office",
  "Durham Police Department",
  "Durham Technical Community College",
  "East Carolina University Emergency Management",
  "East Carolina University Police",
  "East SpeNorth Carolinaer Police Department",
  "Eastern Band Cherokee Indians Tribal Alcohol Law Enforcement",
  "Eastern Band of Cherokee Indians Dept. of Public Safety Communications Center",
  "Eastern Band of Cherokee Indians Office of Tribal Prosecutor",
  "Eden Police Department",
  "Edenton Police Department",
  "Edgecombe County Emergency Management",
  "Edgecombe County Sheriff's Office",
  "Elite Police",
  "Elizabeth City Police Department",
  "Elizabeth City State University Campus Police Department",
  "Elizabeth City State University Emergency Management",
  "Elizabethtown Police Department",
  "Elkin Police Department",
  "Elon Police Department",
  "Elon University Police Department",
  "Emerald Isle Police Department",
  "Eno River State Park",
  "Fair Bluff Police Department",
  "Fairmont Police Department",
  "Falls Lake State Park",
  "Farmville Police Department",
  "Fayetteville Police Department",
  "Fayetteville State University Emergency Management",
  "Fayetteville State University Police and Public Safety",
  "Federal Bureau of Investigation Asheville Hickory",
  "Federal Bureau of Investigation Charlotte",
  "Federal Bureau of Investigation Fayetteville",
  "Federal Bureau of Investigation Greensboro",
  "Federal Bureau of Investigation Greenville",
  "Federal Bureau of Investigation Mecklenburg",
  "Federal Bureau of Investigation Raleigh Cary",
  "Federal Emergency Management AgeNorth Carolinay",
  "Federal Reserve Law Enforcement Unit",
  "First Health of the Carolinas",
  "Fletcher Police Department",
  "Forest City Police Department",
  "Forsyth Correctional Center",
  "Forsyth County Emergency Management",
  "Forsyth County Sheriff's Office",
  "Forsyth Technical Community College Police Department",
  "Fort Bragg Criminal Investigation Division",
  "Fort Bragg Emergency Services",
  "Foxville and Northern RailRoad Police",
  "Franklin Cocunty Emergency Management",
  "Franklin County Communications Center",
  "Franklin County Sheriff's Office",
  "Franklin Police Department",
  "Fuquay-Veterans Affairs in a Police Department",
  "G4S Secure Solutions USA INorth Carolina. Special Police",
  "Garner Police Department",
  "Gaston College Police Department",
  "Gaston County Emergency Managaement",
  "Gaston County Police Department",
  "Gaston County Sheriff's Office",
  "Gastonia Police Department",
  "Gates County Central Communications",
  "Gates County Emergency Managaement",
  "Gates County Sheriff's Office",
  "Gibsonville Police Department",
  "Goldsboro Police Department",
  "Graham County Communications Center",
  "Graham County Sheriff's Office",
  "Graham County Emergency Management",
  "Graham Police Department",
  "Granite Falls Police Department",
  "Granite Quarry - Faith Police Department",
  "Granville County Communications Center",
  "Granville County Emergency Management",
  "Granville County Sheriff's Office",
  "Greene County Emergency Management",
  "Greene County Emergency Services",
  "Greene County Sheriff's Office",
  "Greensboro Fire Department",
  "Greensboro Police Department",
  "Greenville Police Department",
  "Guilford County Emergency Management",
  "Guilford County Sheriff's Office",
  "Guilford Metro 911",
  "Guilford Technical Community College Campus Police",
  "Halifax County Communications Center",
  "Halifax County Emergency Management",
  "Halifax County Sheriff's Office",
  "Hamlet Police Department",
  "Harnett County Emergency Management",
  "Harnett County Emergency Services",
  "Harnett County Sheriff's Office",
  "Harnett Health System Company Police",
  "Havelock Police Department",
  "Haw River Police Department",
  "Haywood County Emergency Management",
  "Haywood County Sheriff's Office",
  "Henderson County Emergency Management",
  "Henderson County Sheriff's Office",
  "Henderson Police Department",
  "Henderson Henderson Communications Center",
  "Hendersonville Police Department",
  "Hertford County E911 Communications Department",
  "Hertford County Emergency Management",
  "Hertford County Sheriff's Office",
  "Hickory Police Department",
  "High Point Communications Center",
  "High Point Parks Police",
  "High Point Police Department",
  "High Point University Campus Police Department",
  "Highlands Police Department",
  "Hillsborough Police Department",
  "Hoke County Emergency Communications",
  "Hoke County Emergency Management",
  "Hoke County Sheriff's Office",
  "Holden Beach Police Department",
  "Holly Ridge Police Department",
  "Holly Springs Police Department",
  "Hope Mills Police Department",
  "Hudson Police Department",
  "Huntersville Police Department",
  "Hyde County Emergency Management",
  "Hyde County Sheriff's Office",
  "Indian Beach Police Department",
  "Iredell County Communications Center",
  "Iredell County Emergency Management",
  "Iredell County Sheriff's Office",
  "Jackson County Communications",
  "Jackson County Emergency Management",
  "Jackson County Sheriff's Office",
  "Jacksonville Police Department",
  "Jefferson Police Department",
  "Johnson C. Smith University Police",
  "Johnston County Emergency 911 Communications",
  "Johnston County Emergency Management",
  "Johnston County Sheriff's Office",
  "Jones County Emergency Management",
  "Jones County Sheriff's Office",
  "Jonesville Police Department",
  "Kannapolis Fire Department",
  "Kannapolis Police Department",
  "KDI Protective Services, INorth Carolina.",
  "Kernersville Police Department",
  "Kill Devil Hills Police Department",
  "King Police Department",
  "Kings Mountain Police Department",
  "Kinston Department of Public Safety",
  "Kitty Hawk Police Department",
  "Knightdale Police Department",
  "Kure Beach Police Department",
  "LabCorp",
  "Lake Lure Police Department",
  "Lake Royale Company Police",
  "Landis Police Department",
  "Laurinburg Police Department",
  "Lee County Emergency Management",
  "Lee County Sheriff's Office",
  "Leland Police Department",
  "Lenoir County Emergency Management",
  "Lenoir County Emergency Services Communications Division",
  "Lenoir County Sheriff's Office",
  "Lenoir Memorial Hospital Company Police",
  "Lenoir Police Department",
  "Lexington Police Department",
  "Liberty Police Department",
  "Lincoln County Communications",
  "Lincoln County Emergency Management",
  "Lincoln County Sheriff's Office",
  "Lincolnton Police Department",
  "Locust Police Department",
  "Long View Police Department",
  "Louisburg Police Department",
  "Lowell Police Department",
  "Lumberton Communications Center",
  "Lumberton Police Department",
  "Macon County Communications",
  "Macon County Emergency Management",
  "Macon County Sheriff's Office",
  "Madison County Emergency Management",
  "Madison County Emergency Services",
  "Madison County Sheriff's Office",
  "Maggie Veterans Affairs",
  "Maiden Police Department",
  "Manteo Police Department",
  "Marion Police Department",
  "Mars Hill Police Department",
  "Marshville Police Department",
  "Martin County Communications",
  "Martin County Emergency Management",
  "Martin County Sheriff's Office",
  "Matthews Police Department",
  "Maxton Police Department",
  "Mayodan Police Department",
  "McDowell County Emergency Communications",
  "McDowell County Emergency Management",
  "McDowell County Sheriff's Office",
  "Mebane Police Department",
  "Mecklenburg County Emergency Management",
  "Mecklenburg County Pretrial Services",
  "Mecklenburg County Sheriff's Office",
  "Methodist University Police and Public Safety Department",
  "Mint Hill Police Department",
  "Mitchell County  Communications",
  "Mitchell County Emergency Management",
  "Mitchell County Sheriff's Office",
  "Monroe Police Department",
  "Montgomery County 911 Communications Center",
  "Montgomery County Emergency Management",
  "Montgomery County Sheriff's Office",
  "Moore County Communications Center",
  "Moore County Emergency Management",
  "Moore County Sheriff's Office",
  "Mooresville Police Department",
  "Morehead City Police Department",
  "Morganton Department of Public Safety",
  "Morrisville Police Department",
  "Mountain Area Healthcare Preparedness Coalition",
  "Mount Airy Police Department",
  "Mount Holly Police Department",
  "Mount Olive Police Department",
  "Murfreesboro Police Department",
  "Murphy Police Department",
  "Nags Head Police Department",
  "Nash County Communications",
  "Nash County Emergency Management",
  "Nash County Sheriff's Office",
  "Nash Health Care Company Police Department",
  "Nashville Police Department",
  "New Bern Police Department",
  "New Hanover County Communications Center",
  "New Hanover County Community Pretrial Release",
  "New Hanover County Emergency Management",
  "New Hanover County Sheriff's Office",
  "New Hanover Regional Medical Center Company Police",
  "Newport Police Department",
  "Newton Police Department",
  "North Carolina  Division of Juvenile Justice",
  "North Carolina A & T University Emergency Management",
  "North Carolina A & T University Police",
  "North Carolina Air National Guard",
  "North Carolina Army National Guard",
  "North Carolina Central University (Campus Police)",
  "North Carolina Child Support Enforcement",
  "North Carolina Criminal Justice Standards",
  "North Carolina Department of Adult Corrections Albemarle Correctional Institution",
  "North Carolina Department of Adult Corrections Alexander Correctional Institution",
  "North Carolina Department of Adult Corrections Avery-Mitchell Correctional Institution",
  "North Carolina Department of Adult Corrections Bertie Correctional Institute",
  "North Carolina Department of Adult Corrections Caledonia Correctional Inst.",
  "North Carolina Department of Adult Corrections Carteret Correctional Center",
  "North Carolina Department of Adult Corrections Caswell Correctional Center",
  "North Carolina Department of Adult Corrections Columbus Correctional Institution",
  "North Carolina Department of Adult Corrections Community Corrections - Wake",
  "North Carolina Department of Adult Corrections Correctional Institution for Women",
  "North Carolina Department of Adult Corrections Craven Correctional Institution",
  "North Carolina Department of Adult Corrections Dan River Prison Work Farm",
  "North Carolina Department of Adult Corrections Division of Prisons",
  "North Carolina Department of Adult Corrections Eastern Correctional Center Maury",
  "North Carolina Department of Adult Corrections Eastern Regional Employment Office",
  "North Carolina Department of Adult Corrections Foothills Correctional Institution",
  "North Carolina Department of Adult Corrections Franklin Correctional Center",
  "North Carolina Department of Adult Corrections Greene Correctional Institution",
  "North Carolina Department of Adult Corrections Harnett Correctional Institution",
  "North Carolina Department of Adult Corrections Hyde Correctional Institution",
  "North Carolina Department of Adult Corrections Johnston Correctional Institution",
  "North Carolina Department of Adult Corrections Lanesboro Correctional Institution",
  "North Carolina Department of Adult Corrections Lumberton Correctional Center",
  "North Carolina Department of Adult Corrections Marion Corrrectional Institution",
  "North Carolina Department of Adult Corrections Maury Correctional Institution",
  "North Carolina Department of Adult Corrections Morrison Correctional Institute",
  "North Carolina Department of Adult Corrections Mountain View Correctional Institution",
  "North Carolina Department of Adult Corrections Nash Correctional Institutute",
  "North Carolina Department of Adult Corrections Neuse Correctional Institution",
  "North Carolina Department of Adult Corrections New Hanover Correctional Institution",
  "North Carolina Department of Adult Corrections Orange Correctional Center",
  "North Carolina Department of Adult Corrections Pamlico Correctional Institution",
  "North Carolina Department of Adult Corrections Pasquotank Correctional Institute",
  "North Carolina Department of Adult Corrections Pender  Correctional Institution",
  "North Carolina Department of Adult Corrections Polk Correctional Institution",
  "North Carolina Department of Adult Corrections Probation and Parole",
  "North Carolina Department of Adult Corrections Raleigh Regional Employment Office",
  "North Carolina Department of Adult Corrections Rowan Correctional Piedmont Minimum",
  "North Carolina Department of Adult Corrections Sampson Correctional Institution",
  "North Carolina Department of Adult Corrections Scotland Correctional Institution",
  "North Carolina Department of Adult Corrections Southern Coastal Plains Regional Employment Office",
  "North Carolina Department of Adult Corrections Southern Correctional Institution",
  "North Carolina Department of Adult Corrections Special Operations Intelligence Unit",
  "North Carolina Department of Adult Corrections Swannanoa Correctional Center for Women",
  "North Carolina Department of Adult Corrections Tabor Correctional Institution",
  "North Carolina Department of Adult Corrections Tyrrell Prison Work Farm",
  "North Carolina Department of Adult Corrections Wake Correctional Facility",
  "North Carolina Department of Adult Corrections Warren Correctional Institution",
  "North Carolina Department of Adult Corrections Western Foothills Regional Employment Office",
  "North Carolina Department of Insurance Division",
  "North Carolina Department of Justice Information Technology Division",
  "North Carolina Department of Justice Medicaid Criminal Investigations Unit",
  "North Carolina Department of Justice Special Prosecutions",
  "North Carolina Department of Motor Vehicles  License and Theft District I",
  "North Carolina Department of Motor Vehicles  License and Theft District II",
  "North Carolina Department of Motor Vehicles  License and Theft District III",
  "North Carolina Department of Motor Vehicles  License and Theft District IV",
  "North Carolina Department of Motor Vehicles  License and Theft District V",
  "North Carolina Department of Motor Vehicles  License and Theft District VI",
  "North Carolina Department of Motor Vehicles  License and Theft District VIII",
  "North Carolina Department of Motor Vehicles License and Theft Headquarters",
  "North Carolina Division of Marine Fisheries",
  "North Carolina Forest Service Law Enforcement",
  "North Carolina General Assembly Police",
  "North Carolina Industrial Commission",
  "North Carolina Innocence Inquiry Commission",
  "North Carolina Metropolitan Special Police",
  "North Carolina National Guard Provost Marshal",
  "North Carolina Port Authority Police",
  "North Carolina Secretary of State Enforcement Section",
  "North Carolina Sheriff's Training & Standards Commission",
  "North Carolina State Bureau of Investigation Administration",
  "North Carolina State Bureau of Investigation Capital District",
  "North Carolina State Bureau of Investigation Coastal District",
  "North Carolina State Bureau of Investigation Computer Crimes Unit",
  "North Carolina State Bureau of Investigation Criminal Information and Identification Section",
  "North Carolina State Bureau of Investigation Criminal Enterprise Investigations Unit",
  "North Carolina State Bureau of Investigation Diversion and Environmental Crimes Unit",
  "North Carolina State Bureau of Investigation FinaNorth Carolinaial Crime Investigations Section",
  "North Carolina State Bureau of Investigation ISAAC Information Sharing and Analysis Center",
  "North Carolina State Bureau of Investigation Medicaid Criminal Investigations Unit",
  "North Carolina State Bureau of Investigation Northeastern District",
  "North Carolina State Bureau of Investigation Northern Piedmont District",
  "North Carolina State Bureau of Investigation Northwestern District",
  "North Carolina State Bureau of Investigation Southeastern District",
  "North Carolina State Bureau of Investigation Southern Piedmont District",
  "North Carolina State Bureau of Investigation Western District",
  "North Carolina State Crime Lab Guilford",
  "North Carolina State Crime Lab Henderson",
  "North Carolina State Crime Lab Wake",
  "North Carolina State Emergency Management DPS",
  "North Carolina State Highway Patrol Headquarters",
  "North Carolina State Highway Patrol Troop B Elizabethtown",
  "North Carolina State Highway Patrol Troop C, A, D Raleigh",
  "North Carolina State Highway Patrol Troop E Salisbury",
  "North Carolina State Highway Patrol Troop F  Newton",
  "North Carolina State Highway Patrol Troop H Monroe",
  "North Carolina State Port Authority Police and Security",
  "North Carolina State University Emergency Management",
  "North Carolina State University Police Department",
  "North Carolina Wildlife",
  "North State Company Police",
  "North Topsail Beach Police Department",
  "North Wilkesboro Police Department",
  "Northampton County Communications",
  "Northampton County Emergency Management",
  "Northampton County Sheriff's Office",
  "Norwood Police Department",
  "Novant Health",
  "Oak Island Police Department",
  "Oakboro Police Department",
  "Ocean Isle Beach Police Department",
  "On Point Company Police LLC",
  "Onslow County 911 Communications",
  "Onslow County Emergency Management",
  "Onslow County Emergency Medical Services",
  "Onslow County Sheriff's Office",
  "Orange County Emergency Communications Center",
  "Orange County Emergency Management",
  "Orange County Sheriff's Office",
  "Oxford Police Department",
  "Pamlico County Emergency Management",
  "Pamlico County Sheriff's Office",
  "Parkton Police Department",
  "Pasquotank County Emergency Management",
  "Pasquotank County Sheriff's Office",
  "Pasquotank-Camden Central Communications Center",
  "Pembroke Police Department",
  "Pender County Emergency Management",
  "Pender County Sheriff's Office",
  "Perquimans County 911 Center",
  "Perquimans County Emergency Management",
  "Perquimans County Sheriff's Office",
  "Person County 911 Communications Center",
  "Person County Emergency Management",
  "Person County Sheriff's Office",
  "Piedmont Company Police Department",
  "Piedmont Triad International Airport Police Department",
  "Piedmont Triad Regional Employment Office",
  "Pilot Mountain Police Department",
  "Pilot Mountain State Park",
  "Pinebluff Police Department",
  "Pinehurst Police Department",
  "Pinetops Police Department",
  "Pineville Police Department",
  "Pink Hill Police Department",
  "Pitt Community College Police Department",
  "Pitt County Emergency Management",
  "Pitt County Sheriff's Office",
  "Plymouth Police Department",
  "Polk County Communications",
  "Polk County Emergency Management",
  "Polk County Sheriff's Office",
  "Polkton Police Department",
  "Princeton Police Department",
  "Queens University Campus Police",
  "Raeford Police Department",
  "Raleigh Durham International Airport Communication Center",
  "Raleigh Durham International Airport Police Department",
  "Raleigh Police Department",
  "Raleigh-Wake City-County Bureau of Identification",
  "Raleigh-Wake Emergency Communications Center",
  "Randleman Police Department",
  "Randolph Community College",
  "Randolph County Communications Center",
  "Randolph County Criminal Justice Day Reporting Center",
  "Randolph County Emergency Management",
  "Randolph County Sheriff's Office",
  "Ranlo Police Department",
  "Raven Rock State Park",
  "Red Springs Police Department",
  "Reidsville Police Department",
  "Richlands Police Department",
  "Richmond County Emergency Management",
  "Richmond County Emergency Services",
  "Richmond County Sheriff's Office",
  "Roanoke Rapids Police Department",
  "Robbins Police Department",
  "Robeson County Communications",
  "Robeson County Emergency Management",
  "Robeson County Sheriff's Office",
  "Rockingham County Communications Center",
  "Rockingham County Emergency Management",
  "Rockingham County Sheriff's Office",
  "Rockingham Police Department",
  "Rockwell Police Department",
  "Rocky Mount Fire Department",
  "Rocky Mount Police Department",
  "Rolesville Police Department",
  "Rosman Fire Rescue",
  "Rowan Cabarrus Community College",
  "Rowan County Communications",
  "Rowan County Emergency Management",
  "Rowan County Emergency Medical Services",
  "Rowan County Sheriff's Office",
  "Rowland Police Department",
  "Roxboro Police Department",
  "Rutherford County Communication Center",
  "Rutherford County Emergency Management",
  "Rutherford County Sheriff's Office",
  "Rutherfordton Police Department",
  "Saint Pauls Police Department",
  "Salisbury Police Department",
  "Saluda Police Department",
  "Sampson County Communications Center",
  "Sampson County Emergency Management",
  "Sampson County Sheriff's Office",
  "Sanford Police Department",
  "Scotland County Emergency Communications",
  "Scotland County Emergency Management",
  "Scotland County Sheriff's Office",
  "Selma Police Department",
  "Shallotte Police Department",
  "Shaw University Police Department",
  "Sheep Dog Company Police",
  "Shelby Police Department",
  "Siler City Police Department",
  "Smithfield Police Department",
  "South Mountains State Park",
  "Southern Pines Police Department",
  "Southern Shores Police Department",
  "Southport Police Department",
  "Sparta Police Department",
  "Spencer Police Department",
  "Spring Lake Police Department",
  "Stallings Police Department",
  "Stanfield Police Department",
  "Stanley Police Department",
  "Stanly County Communications",
  "Stanly County Emergency Management",
  "Stanly County Sheriff's Office",
  "State Capitol Police Department",
  "Statesville Police Department",
  "Stokes County Communications Center",
  "Stokes County Emergency Management",
  "Stokes County Sheriff's Office",
  "Stoneville Police Department",
  "Sunset Beach Police Department",
  "Surf City Police Department",
  "Surry Communications Center",
  "Surry Community College Police Department",
  "Surry County Emergency Management",
  "Surry County Sheriff's Office",
  "Swain County 911",
  "Swain County Emergency Management",
  "Swain County Sheriff's Office",
  "Swansboro Police Department",
  "SylVeterans Affairs Police Department",
  "Tabor City Police Department",
  "Tarboro Police Department",
  "Taylorsville Police Department",
  "Thomasville Fire Department",
  "Thomasville Police Department",
  "Tiger Swan Intel",
  "Transportation Security Administration",
  "Troutman Police Department",
  "Troy Police Department",
  "Truist Bank",
  "Truliant Federal Credit Union",
  "Tryon Police Department",
  "Tyrrell County Sheriff's Office",
  "Union County Communications",
  "Union County Emergency Management",
  "Union County Sheriff's Office",
  "United Special Police",
  "United States Army",
  "United States Army Provost Marshal Office",
  "United States Coast Guard",
  "United States Department of Agriculture",
  "United States Environmental Protection AgeNorth Carolinay",
  "United States Forest Service Law Enforcement",
  "United States Fort Bragg Provost Marshal",
  "United States Health and Human Services",
  "United States Marine Corps Camp Lejeune Military Police",
  "United States Marine Corps Camp Lejuene Communications",
  "United States Marine Corps Cherry Point",
  "United States Navy",
  "United States Secret Service",
  "United States Seymour Johnson Air Force Base",
  "University of North Carolina at Asheville Police Department",
  "University of North Carolina at Chapel Hill Police Department",
  "University of North Carolina at Charlotte Police",
  "University of North Carolina at Greensboro Police Department",
  "University of North Carolina at Pembroke Police Department",
  "University of North Carolina at Wilmington Police Department",
  "University of North Carolina Hospital Special Police",
  "University of North Carolina School of the Arts Police Department",
  "Veterans Affairs Medical Center Police Department - Cumberland",
  "Veterans Affairs Medical Center Police Department - Durham",
  "Veterans Affairs Police Department",
  "Veterans Affairsldese Police Department",
  "Veterans Affairsnia County 911 Center",
  "Veterans Affairsnia County Emergency Management",
  "Veterans Affairsnia County Sheriff's Office",
  "Vidant Company Police",
  "Village of Bald Head Department of Public Safety",
  "Wadesboro Police Department",
  "Wagram Police Department",
  "Wake County Sheriff's Office",
  "Wake Forest Police Department",
  "Wake Forest University Police",
  "Wake Tech Community College Police",
  "WakeMed Campus Police & Public Safety",
  "Wallace Police Department",
  "Warren County Emergency Management",
  "Warren County Sheriff's Office",
  "Warrenton Police Department",
  "Warsaw Police Department",
  "Washington County Emergency Management",
  "Washington County Sheriff's Office",
  "Washington Police Department",
  "Watauga County Department of Communications and Emergency Services",
  "Watauga County Emergency Management",
  "Watauga County Sheriff's Office",
  "Waxhaw Police Department",
  "Wayne County E-911 Communications Center",
  "Wayne County Emergency Management",
  "Wayne County Sheriff's Office",
  "Waynesville Police Department",
  "Weaverville Police Department",
  "Wendell Police Department",
  "Wesleyan College",
  "Western Carolina University Police Department",
  "Western North Carolina Investigation Security and IntelligeNorth Carolinae",
  "Whispering Pines Police Department",
  "White Lake Police Department",
  "Whiteville Police Department",
  "Wilkes County Emergency Management",
  "Wilkes County Sheriff's Office",
  "Wilkesboro Police Department",
  "William B. Umstead State Park",
  "Williamston Police Department",
  "Wilmington Police Department",
  "Wilson County 911 Emergency Communications Center",
  "Wilson County Emergency Management",
  "Wilson County Sheriff's Office",
  "Wilson Police Department",
  "Winston-Salem Fire Department",
  "Winston-Salem Forsyth County Schools",
  "Winston-Salem Police Department",
  "Winston-Salem State University Police",
  "Winterville Community Fire Department",
  "Winterville Police Department",
  "Woodfin Police Department",
  "Wrightsville Beach Police Department",
  "Yadkin County Emergency Management",
  "Yadkin County Sheriff's Office",
  "Yancy County Emergency Management",
  "Yancy County Sheriff's Office",
  "Youngsville Police Department",
  "Zebulon Police Department"
];

export default agencies;